export const STRAPI_URL = "https://modif.o-kiosque.fr";
export const GETINSTANCEINFO_URL =
  "https://getinstanceinfo-5v63jox4za-ey.a.run.app";
